import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import SectionTitle from './SectionTitle';

export default function Mission() {
  const { t } = useLanguage();
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <section
      id="mission"
      data-testid="mission-section"
      className="relative py-32 md:py-44 px-6 md:px-12"
      style={{ background: '#050505' }}
    >
      {/* Decorative line */}
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ width: 0 }}
          whileInView={{ width: '100%' }}
          viewport={{ once: true }}
          transition={{ duration: 1.2 }}
          className="h-px bg-gradient-to-r from-transparent via-[#e14141] to-transparent mb-20"
        />

        <div ref={ref} className="max-w-4xl mx-auto text-center">
          <SectionTitle text={t.mission.label} />

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={inView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="font-heading text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight tracking-tight"
            data-testid="mission-text"
          >
            {t.mission.text}
          </motion.p>
        </div>

        <motion.div
          initial={{ width: 0 }}
          whileInView={{ width: '100%' }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, delay: 0.3 }}
          className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mt-20"
        />
      </div>
    </section>
  );
}
